import _ from 'lodash';
import moment from 'moment';

//function that checks if input is email
export function isEmail(input){
   let reguralExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
   try {
       if(input.match(reguralExp)){
           return true;
       }
       else{
           return false;
       }
   }
   catch (e) {
       return false;
   }
}

//function that checks if input is phone
export function isPhone(input){
    let reguralExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,8}$/im;
    try {
        if(input.match(reguralExp)){
            return true;
        }
        else{
            return false;
        }
    }
    catch (e) {
        return false;
    }
}

//get table rows positions
export function getTableListPostitions(rowsPerPage, page) {
    let start = (page - 1) * rowsPerPage;
    let end = start + rowsPerPage;

    return {start, end}
}

//get new table page
export function getTablePage(iconType, currentPage, totalRows, rowsPerPage) {
    let page = currentPage;
    switch (iconType) {
        case 'firstPage':
            page = 1;
            break;
        case 'lastPage':
            page = _.ceil(totalRows/rowsPerPage);
            break;
        case 'leftPage':
            page = page  > 1 ? page - 1 : 1;
            break;
        case 'rightPage':
            page = page < _.ceil(totalRows/rowsPerPage) ? page + 1 : _.ceil(totalRows/rowsPerPage);
    }
    return page;
}

//calculates the skip filter
export const _getSkipFilter = (page, viewAmount) => (page - 1) * viewAmount;

//function that returns the filter JSON object for requesting the clients suggestions
export const _getClientsSuggestions = (filterText, limit) => {

    const res = {
        where: {
            or: [
                {personId:  {like: "%25" + filterText + "%25"} },
                {lastName:  {like: "%25" + filterText + "%25"} },
                {firstName:  {like: "%25" + filterText + "%25"} },
                {telephone:  {like: "%25" + filterText + "%25"} },
                {country:  {like: "%25" + filterText + "%25"} },
                {address:  {like: "%25" + filterText + "%25"} },
                {badges:  {like: "%25" + filterText + "%25"} },
                {flowers:  {like: "%25" + filterText + "%25"} },
                {leafs:  {like: "%25" + filterText + "%25"} },
                {points:  {like: "%25" + filterText + "%25"} }
            ]
        },
        limit: limit
    };

    return res;

};

export const scrollToElement = (element) => {
    element.scrollIntoView(true);
};

export const dateTypeMapper = (date, dateType) => {
    if(dateType === 'hour'){
        return moment(date).format('HH:mm')
    }
    if(dateType === 'day'){
        return moment(date).format('DD/MM')
    }
    if(dateType === 'week'){
        return moment(date).format('DD/MM')
    }
    if(dateType === 'month'){
        return moment(date).format('MMM')
    }
    return date;
};

export const actionCreator = (type) => {
    return (payload) => {
        return {
            type: type,
            payload: payload
        }
    }
};

export const isAdmin = (userRole) => {
    try {
        return userRole.name === 'admin';
    } catch (e) {
        return false
    }
};


// WEBPACK FOOTER //
// ./src/helpers/functions.js